import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../../services/apiAxios';
import helpers from '../../../mixins/helpers';
import axios from 'axios';
import moment from 'moment';

let requestIndicadorPlazosClientes = axios.CancelToken.source();
let requestIndicadorPlazosProveedores = axios.CancelToken.source();
let requestIndicadorDiferenciaPlazos = axios.CancelToken.source();

const state = {
    indicadorPlazosClientes: {},
    indicadoresPlazosClientesHistorico: [],
    resultadosIndicadorPlazosClientesComprobantes: [],

    indicadorPlazosProveedores: {},
    indicadoresPlazosProveedoresHistorico: [],
    indicadoresPlazosProveedoresAnualHistorico: [],

    indicadorDiferenciaPlazos: {},
    indicadoresDiferenciaPlazosHistorico: [],

    resultadosFormaPago: [],
    resultadosFormaPagoLabels: [],
    resultadosFormaPagoColors: [],
    resultadosFormaPagoData: [],
    resultadosFormaPagoProveedores: [],

    resultadosEvolucionIntereses: [],
    resultadosEvolucionInteresesPeriodos: [],
    resultadosEvolucionInteresesMax: 300000,
    resultadosEvolucionInteresesStep: 25000,

    resultadosEvolucionEmpresaPeriodos: [],
    resultadosEvolucionEmpresa: [],
    resultadosEvolucionEmpresaTabla: [],
    resultadosEvolucionEmpresaTotal: [],
    resultadosEvolucionEmpresaTotalTabla: [],
    resultadosEvolucionEmpresaBarras: [],
    resultadosEvolucionEmpresaMax: 0,
    resultadosEvolucionEmpresaStep: 0,

    resultadosEvolucionRNPeriodos: [],
    resultadosEvolucionRN: [],
    resultadosEvolucionRNMax: 0,
    resultadosEvolucionRNStep: 0,

    resultadosEvolucionPlazosPago: [],
    resultadosEvolucionPlazosPagoBarras: [],
    resultadosEvolucionPlazosPagoPeriodos: [],

    resultados: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES' (state) {
        state.indicadorPlazosClientes = {};
        state.indicadorPlazosProveedores = {};
        state.indicadorDiferenciaPlazos = {};

        state.resultadosFormaPago = [];
        state.resultadosFormaPagoLabels = [];
        state.resultadosFormaPagoColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF'
        ];
        state.resultadosFormaPagoData = [];

        state.resultadosEvolucionIntereses = [];
        state.resultadosEvolucionInteresesPeriodos = [];

        state.resultadosEvolucionEmpresaPeriodos = [];
        state.resultadosEvolucionEmpresa = [];
        state.resultadosEvolucionEmpresaTabla = [];
        state.resultadosEvolucionEmpresaTotal = [];
        state.resultadosEvolucionEmpresaTotalTabla = [];
        state.resultadosEvolucionEmpresaBarras = [];
    },

    'INICIALIZAR_INDICADORES_HISTORICO' (state) {
        state.indicadoresPlazosClientesHistorico = [];
        state.indicadoresPlazosProveedoresHistorico = [];
        state.indicadoresPlazosProveedoresAnualHistorico = [];
        state.indicadoresDiferenciaPlazosHistorico = [];
    
    },

    'SET_INDICADOR_PLAZOS_CLIENTES'(state, indicador) {
        state.indicadorPlazosClientes = indicador;
    },
    'SET_INDICADORES_PLAZOS_CLIENTES_HISTORICO'(state, indicadores) {
        state.indicadoresPlazosClientesHistorico = indicadores;
    },

    'INICIALIZAR_RESULTADOS_INDICADOR_PLAZOS_CLIENTES_COMPROBANTES' (state) {
        state.resultadosIndicadorPlazosClientesComprobantes = [];
    },
    'SET_RESULTADOS_INDICADOR_PLAZOS_CLIENTES_COMPROBANTES'(state, resultados) {
        state.resultadosIndicadorPlazosClientesComprobantes = resultados;
    },

    'SET_INDICADOR_PLAZOS_PROVEEDORES'(state, indicador) {
        state.indicadorPlazosProveedores = indicador;
    },
    'SET_INDICADORES_PLAZOS_PROVEEDORES_HISTORICO'(state, indicadores) {
        state.indicadoresPlazosProveedoresHistorico = indicadores;
    },
    'SET_INDICADORES_PLAZOS_PROVEEDORES_ANUAL_HISTORICO'(state, indicadores) {
        state.indicadoresPlazosProveedoresAnualHistorico = indicadores;
    },
    'INICIALIZAR_RESULTADOS_INDICADOR_PLAZOS_PROVEEDORES_COMPROBANTES' (state) {
        state.resultadosIndicadorPlazosProveedoresComprobantes = [];
    },
    'SET_RESULTADOS_INDICADOR_PLAZOS_PROVEEDORES_COMPROBANTES'(state, resultados) {
        state.resultadosIndicadorPlazosProveedoresComprobantes = resultados;
    },

    'SET_INDICADOR_DIFERENCIA_PLAZOS'(state, indicador) {
        state.indicadorDiferenciaPlazos = indicador;
    },
    'SET_INDICADORES_DIFERENCIA_PLAZOS_HISTORICO'(state, indicadores) {
        state.indicadoresDiferenciaPlazosHistorico = indicadores;
    },

    'SET_RESULTADOS_FORMA_PAGO'(state, resultadosFormaPago) {
        if (resultadosFormaPago) {
            let importeTotal = resultadosFormaPago
                .reduce((total, formaPago) => total + formaPago.importe, 0);

            state.resultadosFormaPago = resultadosFormaPago.map(formaPago => ({
                ...formaPago,
                pjeParticipacion: parseFloat(formaPago.importe) / importeTotal * parseFloat(100)
            }));
        }

        for (let index = 0; index < state.resultadosFormaPago.length; index++) {
            if (index < state.resultadosFormaPagoColors.length) {
                state.resultadosFormaPago[index].color = state.resultadosFormaPagoColors[index];
            }
        }

        state.resultadosFormaPagoLabels = state.resultadosFormaPago
            .map(resultadoFormaPago => resultadoFormaPago.formaPago.trim());
        
        state.resultadosFormaPagoData = state.resultadosFormaPago
            .map(resultadoFormaPago => helpers.methods.roundToTwo(parseFloat(resultadoFormaPago.pjeParticipacion)));
    },
    'INICIALIZAR_RESULTADOS_FORMAS_PAGO_PROVEEDORES' (state) {
        state.resultadosFormaPagoProveedores = [];
    },
    'SET_RESULTADOS_FORMAS_PAGO_PROVEEDORES'(state, resultados) {
        state.resultadosFormaPagoProveedores = resultados.map(resultadosProveedor => ({
            proveedor: resultadosProveedor.proveedor,
            importePesos: resultadosProveedor.importePesos,
            pjePesos: parseFloat(resultadosProveedor.pjePesos) * 100.0,
            importeChequesPropios: resultadosProveedor.importeChequesPropios,
            pjeChequesPropios: parseFloat(resultadosProveedor.pjeChequesPropios) * 100.0,
            importeTransferencias: resultadosProveedor.importeTransferencias,
            pjeTransferencias: parseFloat(resultadosProveedor.pjeTransferencias) * 100.0,
            importeTarjetas: resultadosProveedor.importeTarjetas,
            pjeTarjetas: parseFloat(resultadosProveedor.pjeTarjetas) * 100.0
        }));
    },

    'SET_EVOLUCION_INTERESES' (state, evolucionIntereses) {
        let colors = [ '#E46651', '#41B883', '#FAFA05', '#0000FF', '#FFA500', '#17A204',
            '#04A29D', '#08CADD', '#DD08C6', '#AA1FC8', '#8398CA', '#F19D6E', '#D2DE36',
            '#2DA1D9', '#E62371', '#F06F72', '#97D5D7', '#F0CF71', '#F5CEB5', '#4061AC',
            '#9B9B9B' ];        

        if (evolucionIntereses) {
            let maxImporte = 0;

            evolucionIntereses.forEach(evolucionRubro => {
                evolucionRubro.montoTotal = evolucionRubro.periodos.reduce((total, periodo) => total + parseFloat(periodo.importe), 0);
                let maxRubro = Math.max(...evolucionRubro.periodos.map(t => t.importe))
                
                if (maxRubro > maxImporte) {
                    maxImporte = maxRubro;
                }
            });

            let topeMaximo = Math.ceil(maxImporte / 1000000) * 1000000;
            let stepSize = Math.ceil((topeMaximo / 10) / 1000000) * 1000000;

            state.resultadosEvolucionInteresesStep = Math.ceil(stepSize / 1000000) * 1000000;
            state.resultadosEvolucionInteresesMax = state.resultadosEvolucionInteresesStep * 10;

            // state.resultadosEvolucionInteresesMax = Math.ceil((maxImporte * 1.1) / 100000) * 100000;
            // state.resultadosEvolucionInteresesStep = Math.ceil(state.resultadosEvolucionInteresesMax / 5);

            evolucionIntereses.sort(function(a, b){
                let x = a.montoTotal;
                let y = b.montoTotal;
                if (x < y) { 
                    return 1; 
                }
                if (x > y) {
                    return -1;
                }
                return 0;
            });

            let index = 0;

            evolucionIntereses.forEach(evolucionRubro => {
                    state.resultadosEvolucionIntereses.push({
                        label: evolucionRubro.nombre,
                        backgroundColor: 'transparent',
                        borderColor: colors[index], // '#41B883',
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 2,
                        data: evolucionRubro.periodos.map(periodo => periodo.importe)
                    })
                    index++;
                });

            /* Periodos */
            if (evolucionIntereses.length != 0) {
                let evolucionRubro = evolucionIntereses[0];
                if (evolucionRubro) {
                    if (evolucionRubro.periodos) {
                        evolucionRubro.periodos.forEach(periodoEvolucion => {
                            let mes = '00';
                            if (periodoEvolucion.mes < 10) {
                              mes = '0' + periodoEvolucion.mes.toString().trim();
                            } else {
                              mes = periodoEvolucion.mes.toString().trim();
                            }
                            let periodo = periodoEvolucion.anio.toString().trim() 
                                + '-' + mes
                                + '-01';
                
                            state.resultadosEvolucionInteresesPeriodos.push(moment.utc(periodo).format('MMM/YY'));                            
                        });
                    }
                }
            }
        }
    },

    'SET_EVOLUCION_EMPRESA' (state, evolucionEmpresa) {
        let colors = [ '#0000FF', '#FFA500', '#AA1FC8', '#41B883', '#F0CF71', '#E46651',
                        '#0000FF', '#FFA500', '#E46651'];        

        if (evolucionEmpresa) {
            evolucionEmpresa.forEach(evolucionConcepto => {
                evolucionConcepto.montoTotal = evolucionConcepto.periodos.reduce((total, periodo) => total + parseFloat(periodo.importe), 0);
                evolucionConcepto.montoMaximo = Math.max(...evolucionConcepto.periodos.map(periodo => periodo.importe));
            });

            let index = 0;

            evolucionEmpresa.forEach(evolucionConcepto => {
                let concepto = {
                    label: evolucionConcepto.nombre,
                    backgroundColor: 'transparent',
                    borderColor: colors[index], // '#41B883',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    data: evolucionConcepto.periodos.map(periodo => periodo.importe)
                }

                /* Egresos = Compras + Gastos + Impuestos + Sueldos */
                if (evolucionConcepto.id == 6 || evolucionConcepto.id == 9) {
                    concepto.borderDash = [10,5];
                }
                
                switch (evolucionConcepto.id) {
                    case 1: /* Ventas */
                    case 2: /* Compras */
                    case 6: /* Egresos */
                        state.resultadosEvolucionEmpresa.push(concepto);
                        break;

                    case 3: /* Gastos */
                    case 4: /* Impuestos */
                    case 5: /* Sueldos */
                        state.resultadosEvolucionEmpresa.push(concepto);
                        state.resultadosEvolucionEmpresaTotal.push(concepto);
                        break;
    
                    case 7: /* Ventas Totales */
                    case 8: /* Compras Totales */
                    case 9: /* Egresos Totales */
                        state.resultadosEvolucionEmpresaTotal.push(concepto);
                        break;
                }

                // state.resultadosEvolucionEmpresa.push(concepto);
                switch (evolucionConcepto.id) {
                    case 7: /* Ventas Totales */
                        let conceptoIngresos = {
                            label: 'Ingresos',
                            // backgroundColor: 'transparent',
                            backgroundColor: '#16A085',
                            borderColor: '#16A085',
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data: evolucionConcepto.periodos.map(periodo => periodo.importe)
                        }

                        state.resultadosEvolucionEmpresaBarras.push(conceptoIngresos);
                        break;

                    case 9: /* Egresos Totales */
                        let conceptoEgresos = {
                            label: 'Egresos',
                            // backgroundColor: 'transparent',
                            backgroundColor: '#E74C3C',
                            borderColor: '#E74C3C',
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data: evolucionConcepto.periodos.map(periodo => periodo.importe)
                        }

                        state.resultadosEvolucionEmpresaBarras.push(conceptoEgresos);
                        break;
                }

                index++;
            });

            /* Periodos */
            if (evolucionEmpresa.length != 0) {
                let evolucionConcepto = evolucionEmpresa[0];
                if (evolucionConcepto) {
                    if (evolucionConcepto.periodos) {
                        evolucionConcepto.periodos.forEach(periodoEvolucion => {
                            let mes = '00';
                            if (periodoEvolucion.mes < 10) {
                              mes = '0' + periodoEvolucion.mes.toString().trim();
                            } else {
                              mes = periodoEvolucion.mes.toString().trim();
                            }
                            let periodo = periodoEvolucion.anio.toString().trim() 
                                + '-' + mes
                                + '-01';
                
                            state.resultadosEvolucionEmpresaPeriodos.push(moment.utc(periodo).format('MMM/YY'));
                            
                            /* Generamos la tabla */
                            let ventas = getMontoPeriodo(evolucionEmpresa, 1, periodoEvolucion.anio, periodoEvolucion.mes);
                            let compras = getMontoPeriodo(evolucionEmpresa, 2, periodoEvolucion.anio, periodoEvolucion.mes);
                            let gastos = getMontoPeriodo(evolucionEmpresa, 3, periodoEvolucion.anio, periodoEvolucion.mes);
                            let impuestos = getMontoPeriodo(evolucionEmpresa, 4, periodoEvolucion.anio, periodoEvolucion.mes);
                            let sueldos = getMontoPeriodo(evolucionEmpresa, 5, periodoEvolucion.anio, periodoEvolucion.mes);
                            let ventasTotal = getMontoPeriodo(evolucionEmpresa, 7, periodoEvolucion.anio, periodoEvolucion.mes);
                            let comprasTotal = getMontoPeriodo(evolucionEmpresa, 8, periodoEvolucion.anio, periodoEvolucion.mes);
                            let egresosTotal = getMontoPeriodo(evolucionEmpresa, 9, periodoEvolucion.anio, periodoEvolucion.mes);

                            let periodoTabla = {
                                periodo,
                                ventas,
                                compras,
                                gastos,
                                impuestos,
                                sueldos
                            }
                            state.resultadosEvolucionEmpresaTabla.push(periodoTabla);

                            let periodoTotalTabla = {
                                periodo,
                                ventas: ventasTotal,
                                compras: comprasTotal,
                                gastos,
                                impuestos,
                                sueldos,
                                egresosTotal
                            }
                            state.resultadosEvolucionEmpresaTotalTabla.push(periodoTotalTabla);
                        });
                    }
                }

                let importeMaximo = Math.max(...evolucionEmpresa
                    .filter(evolucionConcepto => evolucionConcepto.id == 7 || evolucionConcepto.id == 8)
                    .map(evolucionConcepto => evolucionConcepto.montoMaximo));
                let topeMaximo = Math.ceil(importeMaximo / 1000000) * 1000000;
                let stepSize = Math.ceil((topeMaximo / 10) / 1000000) * 1000000;
    
                state.resultadosEvolucionEmpresaStep = Math.ceil(stepSize / 50000000) * 50000000;
                state.resultadosEvolucionEmpresaMax = state.resultadosEvolucionEmpresaStep * 10;
            }
        }

        // console.log(state.resultadosEvolucionEmpresaTotal);
    },

    'INICIALIZAR_EVOLUCION_RN' (state) {
        state.resultadosEvolucionRN = [];
        state.resultadosEvolucionRNPeriodos = [];
    },
    'SET_EVOLUCION_RN' (state, indicadores) {
        let evolucionCompras = {
            label: 'Compras',
            backgroundColor: 'transparent',
            borderColor: '#0000FF',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };
        let evolucionSueldos = {
            label: 'Sueldos',
            backgroundColor: 'transparent',
            borderColor: '#FFA500',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };
        let evolucionImpuestos = {
            label: 'Impuestos',
            backgroundColor: 'transparent',
            borderColor: '#AA1FC8',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };
        let evolucionGastosBancos = {
            label: 'Gastos Bancos',
            backgroundColor: 'transparent',
            borderColor: '#41B883',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };
        let evolucionPremiosReembolsos = {
            label: 'Premios/Reembolsos',
            backgroundColor: 'transparent',
            borderColor: '#F0CF71',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };
        let evolucionDeudaComercial = {
            label: 'Deuda Comercial',
            backgroundColor: 'transparent',
            borderColor: '#4D5656',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };
        let evolucionComprasDiferenciaCambio = {
            label: 'Compras Dif.Cambio',
            backgroundColor: 'transparent',
            borderColor: '#6E2C00',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };

        let evolucionEgresos = {
            label: 'Total Egresos',
            backgroundColor: 'transparent',
            borderColor: '#E46651',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            borderDash: [10,5],
            data: []
        };

        if (indicadores) {
            indicadores.forEach(indicador => {
                // console.log(indicador);

                // console.log(moment.utc(indicador.fechaDesde).format('MMM/YY'));

                state.resultadosEvolucionRNPeriodos.push(moment.utc(indicador.fechaDesde).format('YYYY'));

                let participacionCompras = parseFloat(indicador.compras) / parseFloat(indicador.cotizacionTotal);
                participacionCompras *= 100.00;
                let participacionSueldos = parseFloat(indicador.sueldos) / parseFloat(indicador.cotizacionTotal);
                participacionSueldos *= 100.00;
                let participacionImpuestos = parseFloat(indicador.impuestos) / parseFloat(indicador.cotizacionTotal);
                participacionImpuestos *= 100.00;
                let participacionGastosBancarios = parseFloat(indicador.gastosBancarios) / parseFloat(indicador.cotizacionTotal);
                participacionGastosBancarios *= 100.00;
                let participacionPremios = parseFloat(indicador.premiosReembolsos) / parseFloat(indicador.cotizacionTotal);
                participacionPremios *= 100.00;
                let participacionDeudaComercial = parseFloat(indicador.deudaComercial) / parseFloat(indicador.cotizacionTotal);
                participacionDeudaComercial *= 100.00;
                let participacionDiferenciaCambio = parseFloat(indicador.diferenciaCambioCompras) / parseFloat(indicador.cotizacionTotal);
                participacionDiferenciaCambio *= 100.00;
                let participacionTotalEgresos = (parseFloat(indicador.compras)
                    + parseFloat(indicador.sueldos)
                    + parseFloat(indicador.impuestos)
                    + parseFloat(indicador.gastosBancarios)
                    + parseFloat(indicador.premiosReembolsos)
                    + parseFloat(indicador.deudaComercial)
                    + parseFloat(indicador.diferenciaCambioCompras)) / parseFloat(indicador.cotizacionTotal);
                participacionTotalEgresos *= 100.00;

                evolucionCompras.data.push(participacionCompras);
                evolucionSueldos.data.push(participacionSueldos);
                evolucionImpuestos.data.push(participacionImpuestos);
                evolucionGastosBancos.data.push(participacionGastosBancarios);
                evolucionPremiosReembolsos.data.push(participacionPremios);
                evolucionDeudaComercial.data.push(participacionDeudaComercial);
                evolucionComprasDiferenciaCambio.data.push(participacionDiferenciaCambio);
                
                evolucionEgresos.data.push(participacionTotalEgresos);
            });
        }

        state.resultadosEvolucionRN.push(evolucionCompras);
        state.resultadosEvolucionRN.push(evolucionSueldos);
        state.resultadosEvolucionRN.push(evolucionImpuestos);
        state.resultadosEvolucionRN.push(evolucionGastosBancos);
        state.resultadosEvolucionRN.push(evolucionPremiosReembolsos);
        state.resultadosEvolucionRN.push(evolucionDeudaComercial);
        state.resultadosEvolucionRN.push(evolucionComprasDiferenciaCambio);
        state.resultadosEvolucionRN.push(evolucionEgresos);

        // console.log(state.resultadosEvolucionRN, evolucionEgresos);

        // let importeMaximo = Math.max(...evolucionEmpresa
        //     .filter(evolucionConcepto => evolucionConcepto.id == 7 || evolucionConcepto.id == 8)
        //     .map(evolucionConcepto => evolucionConcepto.montoMaximo));
        // let topeMaximo = Math.ceil(importeMaximo / 1000000) * 1000000;
        // let stepSize = Math.ceil((topeMaximo / 10) / 1000000) * 1000000;

        // state.resultadosEvolucionRNStep = Math.ceil(stepSize / 50000000) * 50000000;
        // state.resultadosEvolucionRNMax = state.resultadosEvolucionRNStep * 10;

    },    

    'INICIALIZAR_EVOLUCION_PLAZOS_PAGO' (state) {
        state.resultadosEvolucionPlazosPago = [];
        state.resultadosEvolucionPlazosPagoBarras = [];
        state.resultadosEvolucionPlazosPagoPeriodos = [];
    },
    'SET_EVOLUCION_PLAZOS_PAGO' (state, evolucionPlazosPago) {
        if (evolucionPlazosPago.periodos) {
            state.resultadosEvolucionPlazosPago = evolucionPlazosPago.periodos.map(evolucionPeriodo => ({
                fechaDesde: moment(evolucionPeriodo.fechaDesde).format('YYYY-MM-DD'),
                fechaHasta: moment(evolucionPeriodo.fechaHasta).format('YYYY-MM-DD'),
                periodo: moment(evolucionPeriodo.fechaDesde).format('YYYY-MM-DD'),
                plazoPromedio: helpers.methods.roundToTwo(evolucionPeriodo.plazoPromedio)
            }))
            
            state.resultadosEvolucionPlazosPagoPeriodos = evolucionPlazosPago.periodos
                .map(evolucionPeriodo => moment.utc(evolucionPeriodo.fechaDesde).format('MMM/YY'));

            /* Grafico de barras */
            let concepto = {
                label: 'Plazo Promedio',
                // backgroundColor: 'transparent',
                backgroundColor: '#16A085',
                borderColor: '#16A085',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                data: state.resultadosEvolucionPlazosPago.map(periodo => helpers.methods.roundToTwo(periodo.plazoPromedio))
            }

            state.resultadosEvolucionPlazosPagoBarras.push(concepto);
        }
    },

    'INICIALIZAR_RESULTADOS' (state) {
        state.resultados = [];
    },
    'SET_RESULTADOS' (state, resultados) {
        state.resultados = resultados;
    },
};

function getMontoPeriodo(evolucionEmpresa, evolucionConceptoId, anio, mes) {
    let monto = 0;
    let evolucionConcepto = evolucionEmpresa.find(evolucionConcepto => evolucionConcepto.id == evolucionConceptoId);
    if (evolucionConcepto) {
        let evolucionConceptoPeriodo = evolucionConcepto.periodos.find(periodo => periodo.anio == anio
            & periodo.mes == mes);
        if (evolucionConceptoPeriodo) {
            monto = parseFloat(evolucionConceptoPeriodo.importe);
        }
    }
    return monto;
}


const getters = {
    getField,

    indicadorRentabilidad(state) {
        return state.indicadorRentabilidad;
    },

    indicadorDiferenciaPlazos(state) {
        return state.indicadorDiferenciaPlazos;
    },
    indicadoresDiferenciaPlazosHistorico(state) {
        return state.indicadoresDiferenciaPlazosHistorico;
    },

    indicadorPlazosClientes(state) {
        return state.indicadorPlazosClientes;
    },
    indicadoresPlazosClientesHistorico(state) {
        return state.indicadoresPlazosClientesHistorico;
    },

    indicadorPlazosProveedores(state) {
        return state.indicadorPlazosProveedores;
    },
    indicadorPlazosProveedoresInicializado(state) {
        return state.indicadorPlazosProveedoresInicializado;
    },
    indicadoresPlazosProveedoresHistorico(state) {
        return state.indicadoresPlazosProveedoresHistorico;
    },
    indicadoresPlazosProveedoresAnualHistorico(state) {
        return state.indicadoresPlazosProveedoresAnualHistorico;
    },

    resultadosIndicadorPlazosClientesComprobantes(state) {
        return state.resultadosIndicadorPlazosClientesComprobantes;
    },
    resultadosIndicadorPlazosProveedoresComprobantes(state) {
        return state.resultadosIndicadorPlazosProveedoresComprobantes;
    },

    indicadorDiferenciaPlazos(state) {
        return state.indicadorDiferenciaPlazos;
    },

    resultadosFormaPago(state) {
        return state.resultadosFormaPago;
    },
    resultadosFormaPagoLabels(state) {
        return state.resultadosFormaPagoLabels;
    },
    resultadosFormaPagoColors(state) {
        return state.resultadosFormaPagoColors;
    },
    resultadosFormaPagoData(state) {
        return state.resultadosFormaPagoData;
    },
    resultadosFormaPagoProveedores(state) {
        return state.resultadosFormaPagoProveedores;
    },

    resultadosEvolucionIntereses(state) {
        return state.resultadosEvolucionIntereses;
    },
    resultadosEvolucionInteresesPeriodos(state) {
        return state.resultadosEvolucionInteresesPeriodos;
    },
    resultadosEvolucionInteresesMax(state) {
        return state.resultadosEvolucionInteresesMax;
    },
    resultadosEvolucionInteresesStep(state) {
        return state.resultadosEvolucionInteresesStep;
    },

    resultadosEvolucionEmpresaPeriodos(state) {
        return state.resultadosEvolucionEmpresaPeriodos;
    },
    resultadosEvolucionEmpresa(state) {
        return state.resultadosEvolucionEmpresa;
    },
    resultadosEvolucionEmpresaTabla(state) {
        return state.resultadosEvolucionEmpresaTabla;
    },
    resultadosEvolucionEmpresaTotal(state) {
        return state.resultadosEvolucionEmpresaTotal;
    },
    resultadosEvolucionEmpresaTotalTabla(state) {
        return state.resultadosEvolucionEmpresaTotalTabla;
    },
    resultadosEvolucionEmpresaBarras(state) {
        return state.resultadosEvolucionEmpresaBarras;
    },
    resultadosEvolucionEmpresaMax(state) {
        return state.resultadosEvolucionEmpresaMax;
    },
    resultadosEvolucionEmpresaStep(state) {
        return state.resultadosEvolucionEmpresaStep;
    },

    resultadosEvolucionRNPeriodos(state) {
        return state.resultadosEvolucionRNPeriodos;
    },
    resultadosEvolucionRN(state) {
        return state.resultadosEvolucionRN;
    },
    resultadosEvolucionRNMax(state) {
        return state.resultadosEvolucionRNMax;
    },
    resultadosEvolucionRNStep(state) {
        return state.resultadosEvolucionRNStep;
    },

    resultadosEvolucionPlazosPago(state) {
        return state.resultadosEvolucionPlazosPago;
    },
    resultadosEvolucionPlazosPagoBarras(state) {
        return state.resultadosEvolucionPlazosPagoBarras;
    },
    resultadosEvolucionPlazosPagoPeriodos(state) {
        return state.resultadosEvolucionPlazosPagoPeriodos;
    },

    resultados(state) {
        return state.resultados;
    },    
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');
            resolve();
        })
    },
    getIndicadorDiferenciaPlazos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo')
                .then(res => {
                    commit('SET_INDICADOR_DIFERENCIA_PLAZOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorDiferenciaPlazos() {
        requestIndicadorDiferenciaPlazos.cancel();
        requestIndicadorDiferenciaPlazos = axios.CancelToken.source();
    },
    getIndicadorPlazosClientes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo-clientes')
                .then(res => {
                    commit('SET_INDICADOR_PLAZOS_CLIENTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorPlazosClientes() {
        requestIndicadorPlazosClientes.cancel();
        requestIndicadorPlazosClientes = axios.CancelToken.source();
    },
    getIndicadorPlazosProveedores ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo-proveedores')
                .then(res => {
                    commit('SET_INDICADOR_PLAZOS_PROVEEDORES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorPlazosProveedores() {
        requestIndicadorPlazosProveedores.cancel();
        requestIndicadorPlazosProveedores = axios.CancelToken.source();
    },

    inicializarHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');
            resolve();
        })
    },
    getIndicadoresDiferenciaPlazosHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo/historico')
                .then(res => {
                    commit('SET_INDICADORES_DIFERENCIA_PLAZOS_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresPlazosClientesHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo-clientes/historico')
                .then(res => {
                    commit('SET_INDICADORES_PLAZOS_CLIENTES_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorPlazosClientesComprobantes ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_PLAZOS_CLIENTES_COMPROBANTES');

            apiAxios.get('indicadores/plazo-clientes/comprobantes')
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_PLAZOS_CLIENTES_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorPlazosClientesHistoricoComprobantes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_PLAZOS_CLIENTES_COMPROBANTES');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/plazo-clientes/historico/comprobantes' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_PLAZOS_CLIENTES_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresPlazosProveedoresHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo-proveedores/historico')
                .then(res => {
                    commit('SET_INDICADORES_PLAZOS_PROVEEDORES_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresPlazosProveedoresAnualHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo-proveedores/anual/historico')
                .then(res => {
                    commit('SET_INDICADORES_PLAZOS_PROVEEDORES_ANUAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorPlazosProveedoresComprobantes ( { commit } ) {
        commit('INICIALIZAR_RESULTADOS_INDICADOR_PLAZOS_PROVEEDORES_COMPROBANTES');

        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/plazo-proveedores/comprobantes')
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_PLAZOS_PROVEEDORES_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorPlazosProveedoresHistoricoComprobantes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_PLAZOS_PROVEEDORES_COMPROBANTES');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/plazo-proveedores/historico/comprobantes' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_PLAZOS_PROVEEDORES_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosFormaPago ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/administracion/forma-pago')
                .then(res => {
                    commit('SET_RESULTADOS_FORMA_PAGO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosFormaPagoProveedores ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_FORMAS_PAGO_PROVEEDORES');

            apiAxios.get('indicadores/administracion/forma-pago/proveedores')
                .then(res => {
                    commit('SET_RESULTADOS_FORMAS_PAGO_PROVEEDORES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEvolucionIntereses ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/bancos/intereses/evolucion')
                .then(res => {
                    commit('SET_EVOLUCION_INTERESES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEvolucionEmpresa ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/empresa/evolucion')
                .then(res => {
                    commit('SET_EVOLUCION_EMPRESA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEvolucionRN ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVOLUCION_RN');

            apiAxios.get('indicadores/rentabilidad-neta-anual/historico/total')
                .then(res => {
                    commit('SET_EVOLUCION_RN', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEvolucionPlazosPago ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVOLUCION_PLAZOS_PAGO');

            apiAxios.get('indicadores/plazo-proveedores/evolucion')
                .then(res => {
                    commit('SET_EVOLUCION_PLAZOS_PAGO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEvolucionPlazosPagoComprobantes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            const queryString = `?fechaDesde=${moment(params.fechaDesde).format('YYYY-MM-DD')}`
                + `&fechaHasta=${moment(params.fechaHasta).format('YYYY-MM-DD')}`;
            
            apiAxios.get('indicadores/plazo-proveedores/comprobantes/periodo' + queryString)
            .then(res => {
                commit('SET_RESULTADOS', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}